import TheSoulGroupData from "../../data/projects/theSoulGroup.json"
import Title from "../../components/ProjectPages/Title"
import Section from "../../components/ProjectPages/Section"
import SocialLinks from "../../components/ProjectPages/SocialLinks";
import VideoSection from "../../components/ProjectPages/VideoSection";
import TextTitleSection from "../../components/ProjectPages/TextTitleSection";

/*--------------------
* Building LearnWorks
----------------------*/
export default function TheSoulGroup() {
    var data = JSON.parse(JSON.stringify(TheSoulGroupData));
    data = data[0];
    return (
        <div className="bg-orange-50 h-full pt-[65px] pb-[69px] px-4 md:px-auto w-full">
            <div className="md:w-3/4 w-full mx-auto">
                <Title title="Marketing Expert at WorkNomads" />
                <Section title="Quick intro" content={data.intro} />
                <div className="text-center my-6">
                    {
                        data.social_links.map((val, i) => {
                            return <SocialLinks key={i} link={val.link} icon={val.icon} />
                        })
                    }
                </div>
                <Section title="Video Content Focus" content={data.video_content_description} />
                <VideoSection title="">
                    {
                        data.instagram.map((val, i) => {
                            return <iframe src={val} key={i} className="overflow-hidden h-[600px] w-full rounded-lg" ></iframe>
                        })
                    }
                </VideoSection>
                <Section title="Post Content Focus" key={data.post_content_description} content={data.post_content_description} />
                <VideoSection title="">
                    {
                        data.post_content.map((val, i) => {
                            return <iframe src={val} key={i} className="overflow-hidden h-[600px] w-full rounded-lg" ></iframe>
                        })
                    }
                </VideoSection>
                <TextTitleSection title={data.growth[0].title} text={data.growth[0].text} />
            </div>
        </div>
    )
}
